import { useState } from "react";
import {
  Button,
  Offcanvas,
  Carousel,
  Badge,
  Form,
  Collapse,
} from "react-bootstrap";

const AddonsDetails = ({ Show, Hide, addonData }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  return (
    <Offcanvas show={Show} onHide={Hide} placement="end" style={{ width: 500 }}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title style={{ fontSize: 15 }} className="hstack gap-2">
          <img src={addonData?.icon} style={{ height: 20 }} />
          {addonData?.title}
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body className="p-0">
        {addonData?.banners?.length > 0 && (
          <>
            {addonData?.sliders ? (
              <Carousel
                interval={3000}
                indicators
                className="integration-carousel mb-3 px-2"
              >
                {addonData?.banners?.map((icon, index) => (
                  <Carousel.Item key={index}>
                    <img
                      className="d-block w-100 rounded"
                      src={icon}
                      alt={`Slider ${index + 1}`}
                    />
                  </Carousel.Item>
                ))}
              </Carousel>
            ) : (
              <div className="integration-carousel mb-3">
                <img
                  className="d-block w-100 rounded"
                  src={addonData?.banners?.[0]}
                  alt="Slider"
                />
              </div>
            )}
          </>
        )}
        {addonData?.tags?.length > 0 && (
          <div className="hstack justify-content-between mb-2 px-2">
            <p
              style={{ fontSize: 14 }}
              className="text-muted m-0 hstack gap-1 flex-wrap"
            >
              <span className="fw-bold">Works With: </span>
              {addonData?.tags?.map((tags, index) => (
                <Badge className="rounded-1" key={index}>
                  {tags}
                </Badge>
              ))}
            </p>
          </div>
        )}
        <div
          className="overflow-auto px-2"
          style={{ height: "calc(100vh - 350px)" }}
        >
          <p
            style={{ fontSize: 13 }}
            dangerouslySetInnerHTML={{ __html: addonData?.overview }}
          />
          {addonData?.faqs?.length > 0 && (
            <>
              <p
                style={{ fontSize: 14 }}
                className="text-muted m-0 hstack gap-1 flex-wrap"
              >
                <span className="fw-bold">FAQ </span>
              </p>
              {addonData?.faqs?.map((faq, index) => {
                const isActive = activeIndex === index;

                return (
                  <div key={index} className="mb-2 border-bottom">
                    <div
                      className="d-flex align-items-center justify-content-betwee py-2"
                      onClick={() => toggleFAQ(index)}
                      style={{ cursor: "pointer" }}
                    >
                      <div
                        className="d-flex align-items-center gap-2"
                        style={{ fontSize: 13 }}
                      >
                        <span className="text-primary fw-bold">
                          {isActive ? "▼" : "▶"}
                        </span>
                        <span className="fw-medium">{faq.question}</span>
                      </div>
                    </div>
                    <Collapse in={isActive}>
                      <p
                        className={`ps-4 text-muted `}
                        style={{ fontSize: 12 }}
                      >
                        {faq.answer.replace(/^"|"$/g, "")}
                      </p>
                    </Collapse>
                  </div>
                );
              })}
            </>
          )}
        </div>
      </Offcanvas.Body>

      <div className="justify-content-between p-2 bg-light hstack gap-2">
        <div>
          <Form.Label className="m-0 fw-semibold">
            ${addonData?.monthlyPrice} / month
          </Form.Label>
        </div>

        <div className="hstack gap-2">
          <Button size="sm" variant="outline-primary">
            Chat with us
          </Button>
          <Button size="sm" variant="outline-primary">
            Schedule a call
          </Button>
          <Button size="sm" variant="primary">
            Activate Now
          </Button>
        </div>
      </div>
    </Offcanvas>
  );
};

export default AddonsDetails;
